import React, { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { css } from '@emotion/react';
import { SerializedStyles } from '@emotion/react';
import Image from 'next/image';

type CrimeSearchBarProps = {
  cssProps?: SerializedStyles;
  placeholder?: string;
  queryText: string;
  setQueryText: Dispatch<SetStateAction<string>>;
};

// defaultValue가 주어지는 경우 value는 무시되고 uncontrolled component가 됨. 내부적으로 state 관리가 이루어짐.

export const CrimeSearchBar = ({
  cssProps,
  placeholder = '',
  queryText,
  setQueryText,
}: CrimeSearchBarProps) => {
  const maxNumberOfWords = 400;

  const mobileCss = `width: 100%; font-size:16px;`;

  const countWord = (queryText: string) => {
    const result = queryText.split(' ').length;
    return result;
  };

  const onChange = (ev: ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = ev.target;
    if (value.split(' ').length <= maxNumberOfWords) {
      setQueryText(value);
    } else {
      const limitValue = value.split(' ').slice(0, maxNumberOfWords).join(' ');
      setQueryText(limitValue);
    }
  };

  return (
    <>
      <div
        css={css`
          font-size: 22px;
          font-weight: 700;
          color: #000000;
          width: 80%;
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          align-items: center;
          gap: 1rem;
          @media (max-width: 992px) {
            ${mobileCss}
          }
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
          `}
        >
          <Image
            src='/crime/crime_1.png'
            layout='fixed'
            alt={'Legal Engine'}
            width={25}
            height={25}
          />
          <span
            css={css`
              margin-left: 1rem;
            `}
          >
            {`문제가 된 상황을 알려주세요`}
          </span>
        </div>
        <div
          css={css`
            color: #6f6f6f;
            font-size: 20px;
            font-weight: 400;
            @media (max-width: 992px) {
              font-size: 16px;
            }
          `}
        >
          {`${queryText ? countWord(queryText) : 0} / 400 단어`}
        </div>
      </div>
      <div
        css={css`
          width: 80%;
          padding-left: 0.75rem;
          margin: -1rem 0;
          text-indent: -1rem;
          color: #9b9b9b;
          font-size: 18px;
          @media (max-width: 992px) {
            ${mobileCss}
          }
        `}
      >
        {`※ 언제/어디서/누구와/무엇을 했는지 구체적으로 입력하시면 더욱 정확한 결과가 나옵니다.`}
      </div>
      <textarea
        placeholder={placeholder}
        css={css`
          display: flex;
          flex-flow: row nowrap;
          justify-content: center;
          font-size: 18px;
          font-weight: 400;
          padding: 30px;
          align-items: center;
          width: 80%;
          height: 15rem;
          resize: none;
          font-family: Noto Sans KR, Roboto, sans-serif;
          line-height: 1.5;
          ${cssProps};
          ::placeholder {
            font-size: 18px;
            font-weight: 400;
            color: #6f6f6f;
          }
          &:focus {
            outline: none;
          }
          @media (max-width: 992px) {
            ${mobileCss}
          }
        `}
        value={queryText}
        onChange={(ev) => onChange(ev)}
      />
    </>
  );
};
